
import { createIntroTourFetchFailureAction, createIntroTourFetchRequestAction, createIntroTourFetchSuccessAction } from 'store/IntroTour/introTourAction';
import { ThunkResult } from 'store/store';
import { UsersApi } from 'services/ApiService/ServiceBoard/ServiceBoardApi';
import { logError } from 'core/services/common/logging/logger';



export const GetIntroTour = (): ThunkResult => {
    return async (dispatch) => {
        dispatch(createIntroTourFetchRequestAction());
        try {
            const introTour = await UsersApi.getIntroTour();
            dispatch(createIntroTourFetchSuccessAction(introTour));
        } catch (error: unknown) {
            logError(error);
            dispatch(createIntroTourFetchFailureAction());
        }
    };
};

